import React from "react";
import { Flex } from "../../../../designSystem/compositeComponents/FlexHelpers";
import { PageHeader } from "../../../../designSystem/PageHeader";
import { GeneralCreateIncidentPanel } from "./GeneralCreateIncidentPanel";

export function IncidentWhistleblower():JSX.Element
{
    return (
        <Flex flexDirection='column' gap={16}>

            <PageHeader 
                headerIcon='record_voice_over'
                headerText={`Whistleblower`} />

            <GeneralCreateIncidentPanel type="whistleblower" />
                    
        </Flex>
    );

}